import services from '@/config/services'
import FileManager from '@/services/ask-file-manager/index.js'

export default class ContrattiVenditaService{
  constructor(http, eventBus){
    this.http = http
    this.eventBus = eventBus
    this.baseUrlApi = `${services.ask_base_api.url}`
    this.baseUrl = `${services.ask_api.url}/management`
    this.basePraticheUrl = `${services.ask_pratiche.url}`
    this.filemanager = new FileManager()
  }

  async getAllItemsForMindTable(opts = {}){
    let items = []
    let totalItems = 0

    const url = `${this.baseUrl}/contratti/vendita/search`

    try {
      let res = await this.http.post(url, {filters: opts})
      res = res.data

      items = res.data
      totalItems = res.meta.total_items
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems,
      }
    }

  }

  getAllColumnsForMindTable(){
    return [
      {
        property: 'tipologiacontratto',
        label: '',
        type: {
          isIcon: true
        },
        default: true,
        class: 'icon-tipologia'
      },
      {
        property: 'code',
        label: 'Codice',
        // type: {
        //   isBoolean:true
        //   isCurrency:true
        //   isDate: true
        // },
        default: true,
      },
      {
        property: 'data_firma',
        label: 'Data Firma',
        type: {
          isDate: true
        },
        sortable: true,
        default: true,
      },
      {
        property: 'data_inizio',
        label: 'Data Inizio',
        type: {
          isDate: true
        },
        sortable: true,
        default: true,
      },
      {
        property: 'data_fine',
        label: 'Data Fine',
        type: {
          isDate: true
        },
        sortable: true,
        default: true,
      },
      {
        property: 'offerta',
        label: 'Nome Offerta',
        default: true,
      },
      {
        property: 'ragsoc',
        label: 'Cliente',
        sortable: true,
        default: true,
      },
      {
        property: 'piva',
        label: 'Partita Iva',
        default: true,
      },
      {
        property: 'codfis',
        label: 'Codice Fiscale',
        default: true,
      },
      {
        property: 'rappresentante',
        label: 'Rappresentante',
        sortable: true,
        default: true,
      },
      {
        property: 'istituto',
        label: 'Banca Cliente',
        sortable: true,
        default: true,
      },
      {
        property: 'banca',
        label: 'Banca RID',
        sortable: true,
      },
      {
        property: 'iban',
        label: 'Iban',
        sortable: true,
        default: true,
      },
      {
        property: 'contatto_indirizzo',
        label: 'Indirizzo Contatto',
        default: true,
      },
      {
        property: 'contatto_tel',
        label: 'Telefono Contatto',
        default: true,
      },
      {
        property: 'contatto_email',
        label: 'Email Contatto',
        default: true,
      },
      {
        property: 'contatto_pec',
        label: 'Email Pec',
        default: true,
      },
      {
        property: 'legale',
        label: 'Affido Legale',
      },
      {
        property: 'spedizione',
        label: 'Spedizione',
        default: true,
      },
      {
        property: 'pagamento',
        label: 'Metodo Pagamento',
        default: true,
      },
      {
        property: 'tipo_mandato',
        label: 'Tipo Mandato',
        sortable: true,
        default: true,
      },
      {
        property: 'iva',
        label: 'Iva (%)',
        default: true,
      },
      {
        property: 'fatturazione',
        label: 'Metodo Fatturazione',
        default: true,
      },
      {
        property: 'periodo',
        label: 'Periodo Fatturazione',
        default: true,
      },
      {
        property: 'scadenza',
        label: 'Scadenza a (gg)',
        default: true,
      },
    ]
  }

  async getDettaglioContrattoVendita(id){
    let item = {}

    const url = `${this.baseUrl}/contratti/vendita/${id}`
    try {
      let res = await this.http.get(url)
      res = res.data

      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        item
      }
    }
  }

  async updateInfo(id, info){
    let item = {}
    let success = false

    const url = `${this.baseUrl}/contratti/vendita/${id}/info`
    try {
      let res = await this.http.put(url, {data: info})
      res = res.data

      item = res.data
      success = res.meta.success
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        item,
        success
      }
    }
  }

  async updateRid(id, info){
    let item = {}
    let success = false

    const url = `${this.baseUrl}/contratti/vendita/${id}/rid`
    try {
      let res = await this.http.put(url, {data: info})
      res = res.data

      item = res.data
      success = res.meta.success
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        item,
        success
      }
    }
  }

  async updateProvvigioniAgente(id, info){
    let item = {}
    let success = false

    const url = `${this.baseUrl}/contratti/vendita/${id}/provvigioni-agente`
    try {
      let res = await this.http.put(url, {data: info})
      res = res.data

      item = res.data
      success = res.meta.success
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        item,
        success
      }
    }
  }

  async sendClientLoginEmail(name, email){
    let item = {}

    const url = `${this.baseUrlApi}/client/access-email`
    try {
      let res = await this.http.post(url, {name, email, 'area': 'agf'})
      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        item
      }
    }
  }

  async updateClientiAccessDate(email){
    let success = false

    const url = `${this.baseUrl}/clienti/agenti/access-date/update`
    try {
      let res = await this.http.post(url, {email, type: 'cliente'})
      success = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        success
      }
    }
  }

  async createPodsMassivo(idContratto, file){
    const url = `${this.baseUrl}/contratti/vendita/pods/upload-massivo`
    let fd = new FormData();
    for (let i = 0 ; i < file.length ; i++) {
      fd.append('files[]', file[i]); 
    }

    fd.append('idContratto', idContratto)

    try {
        let res = 
        await this.http({
            url,
            method: 'POST',
            data: fd,
            // responseType: 'blob',
          })
        this.eventBus.emit('data-load-success', {message: res.data})

    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')   
    }
  }


  async updateNewContact(idContratto, newContatto, oldContatto){
    let item = {}

    const url = `${this.baseUrl}/contratti/vendita/contatto/update`
    try {
      let res = await this.http.post(url, {idContratto, newContatto, oldContatto})
      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        item
      }
    }
  }

  async createNewContattoCliente(codeContratto, newContatto, oldCodRapp ) {
    const url = `${this.baseUrl}/contratti/vendita/contatto/create`;
    let response = {};

    try {
        const res = await this.http.post(url, {
            codeContratto,
            newContatto,
            oldCodRapp
        });
        response = res.data; 
    } catch (err) {
        if (err?.response?.status !== 409) {
          this.eventBus.emit('data-load-error', { message: err, url });
        }
        throw err;
    } finally {
        this.eventBus.emit('data-loaded');
    }

    return response; 
  }

  async getCities(value = null){
    let items = {}
    const url = `${this.basePraticheUrl}/get-cities/${value}`

    try {
        let res = await this.http.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }
  }


  async getToponimi() {
    const url = `${this.basePraticheUrl}/get-toponimi`;
    try {
      const res = await this.http.get(url);
      return { items: res.data }; 
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
      return { items: [] };
    } finally {
      this.eventBus.emit("data-loaded");
    }
  }

  async getFornitureVoceFattura(fd){
    let items = {}
    const url = `${this.baseUrl}/get-forniture-voci-fattura`

    try {
      let res = await this.http.post(url, fd)

      items = res.data

    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        items
      }
    }
  }
  async getVociFattura(){
    let items = {}
    const url = `${this.baseUrl}/get-voci-fattura`

    try {
      let res = await this.http.get(url)

      items = res.data

    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        items
      }
    }
  }

  async getAndamentoAgenti(fd){
    let items = {}
    const url = `${this.baseUrl}/agenti/andamento`

    try {
      let res = await this.http.post(url, fd)

      items = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        items
      }
    }
  }

  async getDetailAndamentoAgenti(fd){
    let items = {}
    const url = `${this.baseUrl}/agenti/dettagli-andamento`

    try {
      let res = await this.http.post(url, fd)

      items = res.data

    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        items
      }
    }
  }


  async updateContactField(contactId, fieldName, fieldValue) {
    let success = false;
    const url = `${this.baseUrl}/contratti/vendita/updateContactField`;
   
    try {
      
      let res = await this.http.put(url, {
        id: contactId, 
        [fieldName]: fieldValue, 
      });
  
      res = res.data;
      success = res.success;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");
    }
  
    return { success };
  }

  async downloadPdfAndamento(items){
    const url = `${this.baseUrl}/pdf-andamento`

    try {
        let res = await this.http({
            url,
            method: 'POST',
            data: {'items':items},
            responseType: 'blob',
        })
        this.filemanager.download(res)
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
    }
  }

  async insertIbans(fd){
    let items = []
    const url = `${this.baseUrl}/contratti/vendita/upload-massivo-ibans`

    try {
        let res = 
        await this.http({
            url,
            method: 'POST',
            data: fd
          })
        items = res.data

    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')   
    }

    return {items}
  }
}
